import * as Yup                 from    'yup';
import { PaymentMode } from '../payments.model';

export default Yup.object({

    customer                    :   Yup.string()
                                    .required('Customer is required!')
                                    .notOneOf(['customerid'], 'Select a valid customer!'),

    amount                      :   Yup.number()
                                    .min(1, 'Amount shouldn\'t be 0')
                                    .typeError('Amount should be in numbers!')
                                    .required('Amount is required!'),

    date                        :   Yup.date()
                                    .required('Date is required!')
                                    .typeError('Date is not valid!'),

    transactionId               :   Yup.string()
                                    .notRequired(),

    mode                        :   Yup.string()
                                    .required('Payment mode is required!')
                                    .oneOf([PaymentMode.CASH, PaymentMode.CHEQUE, PaymentMode.NEFT, PaymentMode.RTGS], 'Select valid payment!')
})